/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Modal, Row, Upload, message } from 'antd';
import ImgCrop from 'antd-img-crop';
import type { UploadChangeParam } from 'antd/es/upload';
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface';
import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
// import './index.scss'
import styled from 'styled-components';
import axiosInstance from '../../../../axios_instance';
import ModalCloseIcon from '../../icon';

const StyledUpload = styled(Upload)`

  .ant-upload-list-item{
    margin-left:20px !important;
    border-radius:50%  !important;
    height:152px !important;
    width:152px !important;
    padding:5px !important;
    border:1px solid #303843 !important;
    pointer-events:none
  }
  .ant-upload-list-item-thumbnail{
    border-radius:50% !important;
    height:160px !important;
    width:160px !important;
    
  }
 
}

.ant-upload.ant-upload-select{
  position:relative;
  top:45px;
  left:120px;
  height:40px !important;
  width:140px !important;
  border:1px solid #303843 !important;
  background:#59606A !important;
  border-radius:6px !important;
  font-family: 'Open Sans';
font-style: normal;
font-weight: 600;
font-size: 13px;
line-height: 18px;


`;

const StyledModal = styled(Modal)`
  background-color: #303843;
  font-size: 32px;
  color: white;
  padding-bottom: 0px;
  width:584px;
  height:360px;
  border-radius:5px;
  .ant-modal-body{
    height:180px
  }
  .ant-modal-close{
    position:absolute;
    top:35px;
    right:40px
  }
  .ant-modal-content {
    background-color: #303843;
    padding: 10px;
    height:360px;
  }
  .ant-modal-title {
    color: white;
    margin: 20px;
    margin-left:40px !important;
    font-size: 20px;
  }
  div {
    color: white;
  }
  .ant-modal-header {
    background-color: #303843;
  }
  .ant-upload-wrapper {
    margin: 20px;
  }
  .anticon {
    color: white;
  }
  .ant-btn-primary{

    height:40px;
    width:70px;
    
    background: #8CC63E;
    border-radius: 4px;
    margin-right:20px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    margin-top:auto;
        margin-bottom:20px
    
    /* White */
    
    color: #FFFFFF;
    :not(:disabled):hover{
      background-color: #8CC63E !important;
    }
      }
      .ant-btn-default{
        font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    
    /* White */
    
    color: #FFFFFF;
    
        height:40px;
        width:80px;
        box-shadow: -2px 10px 30px rgba(0, 0, 0, 0.25);
        background: #303843;
        border-radius: 4px;
        margin-right:10px
        margin-top:auto;
        margin-bottom:20px
        
            
          }
`;
interface ProfilePictureUploadModalProps {
  isModalOpen: boolean;
  setIsModalOpen: any;
  userProfilePictureData: any;
}
const ProfilePictureUploadModal: React.FC<ProfilePictureUploadModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  userProfilePictureData,
}: ProfilePictureUploadModalProps) => {
  const [picture, setPicture] = useState<UploadFile[]>([
    {
      uid: '-1',
      name: 'image.png',
      status: 'done',
      url: userProfilePictureData,
    },
  ]);
  const [originalPictureSize, setOriginalPictureSize] = useState<number>();
  //dummy image element created to check whether the image is available or not.
  useEffect(() => {
    if (isModalOpen) {
      const dummyImage = document.createElement('img');
      dummyImage.src = userProfilePictureData;
      dummyImage.onerror = () => {
        setPicture([
          {
            uid: '-1',
            name: 'image.png',
            status: 'done',
            url: 'no_image.png',
          },
        ]);
      };
    }
  }, [isModalOpen]);
  const [uploadFile, setUploadFile] = useState<RcFile>();
  const [errorMessage, setErrorMessage] = useState<string>('');

  const dummyRequest = (options: any) => {
    setTimeout(() => {
      options.onSuccess('Ok');
    }, 1000);
  };

  const beforeUpload = (file: RcFile) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      setErrorMessage('You can only upload JPG/PNG file!');
    }
    const isFileNameCorrect = file.name.split('.').length < 3;
    if (!isFileNameCorrect) {
      setErrorMessage('File name or/and type are incorrect!');
    }
    const isLt2M =
      originalPictureSize && originalPictureSize / 1024 / 1024 < 0.3;
    if (!isLt2M) {
      setErrorMessage('Image must be smaller than 300kb!');
    }
    return isJpgOrPng && isLt2M && isFileNameCorrect;
  };
  const handleFileStatus: UploadProps['onChange'] = (
    info: UploadChangeParam<UploadFile>
  ) => {
    if (info.file.status === 'uploading') {
      setOriginalPictureSize(info.file?.size);
    }
    if (info.file.status === 'error') {
      setErrorMessage(`${info.file.name} 
                       file upload failed.`);
      setUploadFile(info.file.originFileObj as RcFile);
    }
    if (info.file.status === 'done') {
      setErrorMessage('');
      setUploadFile(info.file.originFileObj as RcFile);
      // Get this url from response in real world.
      // window.location.reload();
    }
  };
  const onChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
    setPicture(newFileList);

    console.log(userProfilePictureData);
  };

  const handleOk = () => {
    const formData = new FormData();

    if (uploadFile && beforeUpload(uploadFile)) {
      console.log(beforeUpload(uploadFile));
      formData.append('file', uploadFile);
      axiosInstance.defaults.headers['Content-Type'] = 'multipart/form-data';
      axiosInstance
        .post('/api/v1/profile/files/upload-profile-picture', formData)
        .then((response) => {
          message.success(`Image uploaded successfully!`);
          setErrorMessage('');
          setIsModalOpen(false);
          window.location.reload();
        })
        .catch((error) => {
          setErrorMessage('Wrong file!Give correct file to upload.');
        });
    }
    axiosInstance.defaults.headers['Content-Type'] = 'application/json';
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setUploadFile(undefined);
    setErrorMessage('');
    setPicture([
      {
        uid: '-1',
        name: 'image.png',
        status: 'done',
        url: userProfilePictureData,
      },
    ]);
  };

  return (
    <>
      {isModalOpen ? (
        <StyledModal
          closable
          destroyOnClose={true}
          title="Change Profile Picture"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          style={{ pointerEvents: 'none' }}
          okText={'Save'}
          closeIcon={<ModalCloseIcon />}
        >
          <Row style={{ height: '200px' }}>
            <Col span={24} style={{ height: '200px' }}>
              <ImgCrop rotate>
                <StyledUpload
                  customRequest={dummyRequest}
                  listType="picture-card"
                  fileList={picture}
                  onChange={(UploadProps) => {
                    handleFileStatus(UploadProps);
                    onChange(UploadProps);
                  }}
                  maxCount={1}
                  onRemove={() => {
                    return false;
                  }}
                  // beforeUpload={()=>{false}}
                  progress={{
                    strokeColor: '#303843',
                    showInfo: false,
                    strokeWidth: 1,
                  }}
                >
                  {'Select Image'}
                </StyledUpload>
              </ImgCrop>
              <p className={styles['upload-rule']}>Maximum size 300kb</p>
              <p className={styles['error-message']}>{errorMessage}</p>
            </Col>
          </Row>
        </StyledModal>
      ) : (
        <></>
      )}
    </>
  );
};

export default ProfilePictureUploadModal;
